// Counts in-flight API requests so a single global loader can show while any of them is pending.
let pendingCount = 0;
const listeners = new Set();

const notify = () => listeners.forEach(listener => listener(pendingCount > 0));

export const startRequest = () => {
    pendingCount += 1;
    notify();
};

export const endRequest = () => {
    pendingCount = Math.max(0, pendingCount - 1);
    notify();
};

export const subscribeToLoading = listener => {
    listeners.add(listener);
    listener(pendingCount > 0);
    return () => listeners.delete(listener);
};

export const attachLoadingInterceptors = axiosInstance => {
    axiosInstance.interceptors.request.use(
        config => {
            startRequest();
            return config;
        },
        error => {
            endRequest();
            return Promise.reject(error);
        }
    );
    axiosInstance.interceptors.response.use(
        response => {
            endRequest();
            return response;
        },
        error => {
            endRequest();
            return Promise.reject(error);
        }
    );
};
